<template>
    <div id="appointment-deposit">
        <div class="vx-breadcrumb mb-6">
            <ul class="flex flex-wrap items-center">
                <li class="inline-flex items-end">
                    <router-link to="/after-login"><feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" /></router-link>
                    <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
                </li>
                <li class="inline-flex items-end">
                    <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Appointment Deposit</span>
                </li>
            </ul>
        </div>

        <vs-table :data="depositData.items" :max-items="itemsPerPage">
            <div slot="header" class="w-full flex align-center justify-between my-header">
                <!-- <transition name="list">
                    <vs-button type="border" color="danger" class="text-base gradient gradient-danger no-shadow px-6 delete-btn" v-show="selectedNum > 0" @click="deletePopupActive = true">
                        Delete selected
                    </vs-button>
                </transition> -->
                <div>
                  <vs-checkbox v-model="isNoShow">No show</vs-checkbox>
                </div>
                <div class="flex-center right-header">
                    <div class="con-input-search vs-table--search">
                        <input type="text" class="input-search vs-table--search-input" placeholder="Search customer" v-model="search" @keyup="searchCustomer" />
                        <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                    </div>
                    <vs-dropdown vs-trigger-click class="cursor-pointer item-per-page-dropdown" v-if="depositData._meta && depositData._meta.totalCount > 0">
                        <div class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">
                                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ depositData._meta.totalCount - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : depositData._meta.totalCount }} of {{ depositData._meta.totalCount }}
                            </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu style="width: 80px">
                            <vs-dropdown-item v-for="(item, i) in itemsPerPageOptions" :key="i" @click="changeItemsPerPage(item)" v-model="itemsPerPage">
                                <span class="w-full flex justify-between" :class="{'text-primary': itemsPerPage == item}">
                                    {{item}}
                                    <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="itemsPerPage == item" />
                                </span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    <date-picker
                      class="created-date-picker"
                      :format="date_format_string"
                      v-model="date_filter"
                      type="date"
                      :editable="false"
                      placeholder="Filter date"
                      @change="changePage(1)"
                    ></date-picker>
                    <vs-button class="ml-6 refresh-btn" @click="reloadList">Refresh</vs-button>
                </div>
            </div>
            <template slot="thead">
                <!-- <vs-th class="flex-center" v-if="depositData.items && depositData.items.length > 0">
                    <vs-checkbox :value="isAllSelected" @click="checkAll"></vs-checkbox>
                </vs-th> -->
                <vs-th class="center-title text-center">Name</vs-th>
                <vs-th class="center-title text-center">Date</vs-th>
                <vs-th class="center-title text-center">Status</vs-th>
                <vs-th class="center-title text-center">Services</vs-th>
                <vs-th class="center-title text-center">Staff</vs-th>
                <vs-th class="center-title text-center">Deposit</vs-th>
                <vs-th class="center-title text-center">Refund</vs-th>
                <vs-th class="center-title text-center">Action</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="shadow-md" :class="{'is-selected' : tr.delete_status}" @click.native="openDetailPopup(tr)">
                    <!-- <vs-td>
                        <vs-checkbox :value="tr.delete_status" @click.stop="changeDeleteStatus(indextr)" :key="tr.id" v-if="tr.status != 'cancelled' && tr.status != 'payment_success'"></vs-checkbox>
                        <vs-checkbox v-else class="visibility-hidden"></vs-checkbox>
                    </vs-td> -->
                    <vs-td class="break-word" style="min-width: 160px;" :data="data[indextr].customer_name">
                        <h5 class="font-bold">{{ tr.customer_name }}</h5>
                        <p v-if="tr.customer_phone" class="mt-2">
                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 font-bold mr-1" />
                            <span>{{ StringHelper.phoneNumberFormat(tr.customer_phone) }}</span>
                        </p>
                    </vs-td>
                    <vs-td class="text-center" :data="data[indextr].created_at">
                        <p class="text-center">{{ changeFormat(tr.created_at) }}</p>
                        <p class="text-center">{{ getTime(tr.created_at) }}</p>
                    </vs-td>
                    <vs-td class="text-center" :data="data[indextr].status">
                        <vs-alert :color="getStatusColor(tr.status)" class="flex align-center justify-center mx-auto" style="width: 100px; height: 32px !important">{{ getStatusName(tr.status) }}</vs-alert>
                    </vs-td>
                    <vs-td class="text-center break-word" style="min-width: 100px;" :data="data[indextr].services">
                        <span v-for="(service, i) in tr.services" :key="i">
                            <span v-if="i == tr.services.length - 1">{{ service }}</span>
                            <span v-else>{{ service }}, </span>
                            <br />
                        </span>
                    </vs-td>
                    <vs-td class="text-center break-word" style="min-width: 100px;" :data="data[indextr].staff">
                        <span v-for="(st, i) in tr.staff" :key="i">
                            <span v-if="i == tr.staff.length - 1">{{ st }}</span>
                            <span v-else>{{ st }}, </span>
                            <br />
                        </span>
                    </vs-td>
                    <vs-td class="text-center text-lg text-primary" :data="data[indextr].amount">+${{ tr.amount / 100 }}</vs-td>
                    <vs-td class="text-center text-lg text-danger" :data="data[indextr].refund">
                        <span v-if="tr.total_refund">-${{ tr.total_refund / 100 }}</span>
                        <span v-else>0</span>
                    </vs-td>
                    <vs-td>
                        <div class="flex-center">
                            <vs-button class="px-4 refund-btn" @click.stop="openRefundPopup(tr)" v-if="tr.balance != 0">Refund</vs-button>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <!-- <vs-popup class="holamundo delete-staff-popup" title="Delete Item" :active.sync="deletePopupActive">
            <div class="text-center">
                <h3 v-if="selectedNum > 1">Do you want to delete these items?</h3>
                <h3 v-else>Do you want to delete this item?</h3>
                <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                    <vs-button class="mr-6 align-center delete-responsive">Delete</vs-button>
                    <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="deletePopupActive = false">Cancel</vs-button>
                </div>
            </div>
        </vs-popup> -->
        <div v-if="depositData._meta && depositData._meta.pageCount > 1">
            <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(depositData._meta.pageCount)" :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
        </div>
        <refund-popup :refundPopupConfig="refundPopupConfig" :key="'refund-' + refund_key" @GetData="getData"></refund-popup>
        <deposit-detail-popup
          :depositDetailPopup="depositDetailPopup"
          @OpenAppointmentDetail="openAppointmentDetail"
          @OpenOrderPopup="openOrderPopup" :key="'deposit-detail-' + detail_key"
          @changeSuccess="reloadList"
        ></deposit-detail-popup>
        <appointment-popup :config="appointmentPopupConfig" :isFromDeposit="true" @closePopup="closeAppointmentDetail" @edit="editAppointment" :key="appointmentPopupConfig.appointmentId + appointmentPopupConfig.key" />
        <appointment-edit-popup v-if="popupEditConfig.isActive" :config="popupEditConfig" @closePopup="closeEditPopup" :key="'edit-appointment-' + popupEditConfig.key" />
        <vs-popup-order-detail :popupOrderDetail="orderDetailConfig" :active_id="order_id" :key="'order-detail-' + order_key" @ClosePopup="closeOrderPopup" v-if="order_id != null"></vs-popup-order-detail>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { StringHelper } from "../../models/string_helper";
import { changeFormatHelper, formatDateString } from '../../helper/datetimeHelper';
import AppointmentPopup from "../../views/appointment/AppointmentPopup.vue";
import AppointmentEditPopup from "../../views/appointment/AppointmentEditPopup.vue";
import DepositDetailPopup from "../../components/apppointment/DepositDetailPopup.vue";
import RefundPopup from "../../components/apppointment/RefundPopup.vue";

import moment from 'moment';
export default {
    components: {RefundPopup, DepositDetailPopup, DatePicker, AppointmentPopup, AppointmentEditPopup },
    data() {
        let date_format_string = formatDateString();
        return {
            StringHelper,
            date_format_string,
            search: "",
            itemsPerPageOptions: [10, 15, 20, 30, 50],
            currentPage: 1,
            itemsPerPage: 10,
            page_key: 0,
            date_filter: null,
            deletePopupActive: false,
            refundPopupConfig: {
                isOpen: false,
                item_info: null
            },
            depositDetailPopup: {
                isOpen: false
            },
            detail_key: 0,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: "",
            refund_key: 0,
            appointmentPopupConfig: {
                isActive: false,
                appointmentId: null,
                key: 10000,
            },
            popupEditConfig: {
                isActive: false,
                isNewEvent: true,
                appointmentId: null,
                initDate: null,
                key: 0,
                staff_id: null,
            },
            orderDetailConfig: {
                isOpen: false
            },
            order_id: null,
            order_key: 0,
            isNoShow: true,
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Deposit Data Failed";
                    this.openLoadingInDiv();
                }
            }
        },
        isNoShow() {
          this.getData();
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type,
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        changeFormat(day) {
            if(day) return changeFormatHelper(day);
            return 'N/A';
        },
        getTime(date) {
            if(date) return moment(date).format('hh:mm A');
            return '';
        },
        getStatusColor(status) {
            if(status == "Success") return "success";
            if(status == "Failed") return "danger";
            return "purple";
        },
        getStatusName(status) {
            if(status == "Success") return "Success";
            if(status == "Failed") return "Failed";
            return status;
        },
        changePage(currentPage) {
            this.currentPage = currentPage;
            this.page_key++;
            this.getData();
        },
        changeItemsPerPage(itemsPerPage) {
            this.itemsPerPage = itemsPerPage;
            this.currentPage = 1;
            this.page_key++;
            this.getData();
        },
        searchCustomer({ target }) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }

            this.search = target.value;
            this.currentPage = 1;
            this.page_key++;

            this.timer = setTimeout(() => {
                this.getData();
            }, 500);
        },
        getData() {
            const obj = {...this.getDepositListRequest};
            if(this.search && this.search != "") {
                obj.keyword = this.search;
            }
            this.action_type = "Get Deposit Data Failed";
            this.openLoadingInDiv();
            this.$store.dispatch("appointment/GET_DEPOSIT_LIST", obj).then(() => {
                this.closeLoading();
            })
        },
        checkAll() {
            this.$store.commit("appointment/CHANGE_ALL_DELETE_STATUS", !this.isAllSelected);
        },
        changeDeleteStatus(index) {
            this.$store.commit("appointment/CHANGE_DELETE_STATUS", index);
        },
        openDetailPopup(item) {
            let obj = {
                id: item.id
            }
            this.action_type = "Get Deposit Data Failed";
            this.openLoadingInDiv();
            this.$store.dispatch("appointment/GET_DEPOSIT_DETAIL", obj).then(() => {
                this.depositDetailPopup.isOpen = true;
                this.detail_key++;
                this.closeLoading();
            })
        },
        openRefundPopup(item) {
            this.refundPopupConfig.item_info = item;
            this.refundPopupConfig.isOpen = true;
            this.refund_key++;
        },
        openAppointmentDetail(id, reopen = false) {
            if(reopen) {
                this.appointmentPopupConfig = {
                    appointmentId: id,
                    isActive: true,
                    key: this.appointmentPopupConfig.key + 1,
                };
            } else {
                this.action_type = "Get Appontment Detail Data";
                this.openLoadingInDiv();
                this.$store.dispatch("appointment/GET_APPOINTMENT_DETAIL", { id }).then(() => {
                    this.closeLoading();
                    this.appointmentPopupConfig = {
                        appointmentId: id,
                        isActive: true,
                        key: this.appointmentPopupConfig.key + 1,
                    };
                }).catch((error) => {
                    this.$vs.dialog({
                        color: "danger",
                        title: "Appointment detail",
                        text: error,
                        acceptText: "OK",
                    });
                });
            }
        },
        closeAppointmentDetail() {
            this.appointmentPopupConfig.isActive = false;
        },
        editAppointment(id) {
            this.appointmentPopupConfig.isActive = false;
            this.popupAddNew(null, id);
        },
        popupAddNew(initDate = null, appointmentId = null) {
            this.popupEditConfig.key = this.popupEditConfig.key + 1;
            this.popupEditConfig.isActive = true;
            if (appointmentId) {
                this.popupEditConfig.appointmentId = appointmentId;
                this.popupEditConfig.isEdit = true;
            } else {
                this.popupEditConfig.appointmentId = null;
                this.popupEditConfig.isEdit = false;
            }
            if (initDate) {
                this.popupEditConfig.initDate = initDate.date;
                if (initDate.resource != null) {
                    this.popupEditConfig.staff_id = initDate.resource.id;
                } else if (initDate.dayEl && initDate.dayEl.dataset.resourceId !== undefined) {
                    this.popupEditConfig.staff_id = initDate.dayEl.dataset.resourceId;
                }
            }
            if (initDate == null && appointmentId == null) {
                this.$store.dispatch("appointment/GET_APPOINTMENT_SPECIFIC_DATE", { date: moment().format("YYYY-MM-DD") });
            }
        },
        closeEditPopup(data) {
            if (data.appointment_id != null && data.appointment_id != false) {
                this.openAppointmentDetail(data.appointment_id);
            } else if (data.reopen == true) {
                this.openAppointmentDetail(this.appointmentDetail.id, true);
            }
            this.popupEditConfig.isActive = false;
        },
        openOrderPopup(id) {
            this.orderDetailConfig.isOpen = true;
            this.order_id = id;
            this.order_key++;
        },
        closeOrderPopup() {
            this.orderDetailConfig.isOpen = false;
        },
        reloadList() {
            this.depositDetailPopup.isOpen && (this.depositDetailPopup.isOpen = false);
            // this.search = '';
            // this.date_filter = new Date();
            this.getData();
            // let obj = {
            //     date: moment(this.date_filter).format("YYYY-MM-DD"),
            // }
            // this.action_type = "Reload Deposit List Failed";
            // this.openLoadingInDiv();
            // this.$store.dispatch("appointment/RELOAD_DEPOSIT_LIST", obj).then(() => {
            //     this.closeLoading();
            //     this.getData();
            // })
        },
    },
    computed: {
        depositData() {
            return this.$store.getters["appointment/depositList"];
        },
        isAllSelected() {
            return this.$store.getters["appointment/depositDeleteStatus"].isAllSelected;
        },
        selectedNum() {
            return this.$store.getters["appointment/depositDeleteStatus"].selectedNum;
        },
        getDepositListRequest() {
          return {
            date: this.date_filter && moment(this.date_filter).format("YYYY-MM-DD"),
            page: this.currentPage,
            "per-page": this.itemsPerPage,
            no_show: this.isNoShow ? 1 : 0,
          }
        }
    },
    created() {
        const obj = {...this.getDepositListRequest};
        this.$store.dispatch("appointment/GET_DEPOSIT_LIST", obj).then(() => {
            this.loaded_data_num++;
        })
    },
}
</script>
